'use client';

import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center">
      <h2 className="mb-4 font-bold text-2xl">404 - Page Not Found</h2>
      <p className="mb-4">Could not find the requested resource</p>
      <Link
        href="/"
        className="font-medium text-primary-600 hover:text-primary-500"
      >
        Return Home
      </Link>
    </div>
  );
}
